import React from "react";
import {TextField, Typography} from "@mui/material";
import { useTranslation } from "react-i18next";
import clsx from "clsx";
import {fromApp} from "../../../../config/values";

const RayaField = React.forwardRef((props, ref) => {
    const { t } = useTranslation();
    const { optional, slotProps, type, className, ...rest } = props;
    let label = optional ? `${props.label}${t("optionalField")}` : props.label;

    const mergedSlotProps =
        type === "date"
            ? { ...slotProps, inputLabel: { shrink: true, ...slotProps?.inputLabel } }
            : slotProps;

    return (
        <>
            {!!fromApp() && <Typography className="app-label">{label}</Typography>}
            <TextField
                {...rest}
                type={type}
                slotProps={mergedSlotProps}
                required={false}
                label={!fromApp() ? label : ""}
                color="field"
                className={clsx("raya-field", className)}
                inputRef={ref}
            />
        </>
    );
});

export default RayaField;
